
































import Vue from 'vue'
import { IDescriptionTemplate } from '@/api/types/response.types'

export default Vue.extend({
  name: 'EditorSavedTemplates',

  props: {
    savedTemplates: {
      type: Array as () => IDescriptionTemplate[],
      default: Array as () => IDescriptionTemplate[],
    },

    message: {
      type: String,
      default: '',
    },

    isDisabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isOpen: false,
      selectedTemplateId: null,
      selectedTemplateBody: '',
    }
  },

  watch: {
    message: {
      immediate: true,
      handler(value) {
        // remove HTML to compare only the content of the saved reply
        const valueWithoutHTML = value.replace(/<(?!\s*\/?\s*img)[^>]*>/gi, '')
        const selectedWithoutHTML = this.selectedTemplateBody.replace(
          /<(?!\s*\/?\s*img)[^>]*>/gi,
          '',
        )

        if (valueWithoutHTML !== selectedWithoutHTML) {
          this.selectedTemplateBody = ''
          this.selectedTemplateId = null
        }
      },
    },
  },

  methods: {
    handleSelect(item: any) {
      this.selectedTemplateId = item.id
      this.setSelectedReply(item.description)
      this.isOpen = false
    },

    /**
     * Emit event to Editor to apply the saved reply
     */
    setSelectedReply(savedTemplateBody: string) {
      this.selectedTemplateBody = savedTemplateBody
      this.$emit('selected-saved-template', savedTemplateBody)
    },
  },
})
